import React, { useEffect, useState, useRef } from 'react';
import { Link } from 'react-router-dom';
import * as Icon from 'react-feather';
import { useDispatch, useSelector } from 'react-redux';
import { AppDispatch } from '../../core/data/redux/store';
import { Toast } from 'primereact/toast';
import { Col } from 'antd';
import { getAllProjects, updateProject } from '../../services/projectServices';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import TableNotFound from '../common/components/TableNotFound';
import { formatDate } from '../../utils/formatDate';
import ProjectsModal from '../../feature-module/admin/common/modals/projects-modal';

const ListProjects = () => {
  const dispatch = useDispatch<AppDispatch>();
  const toast = useRef<Toast>(null);
  const data = useSelector((state: any) => state.project);
  const {
    projects,
    isError,
    isLoading,
    errorMessage,
    projectCreated,
    projectUpdated,
  } = useSelector((state: any) => ({
    projects: state.project.projects,
    isError: state.project.isError,
    isLoading: state.project.isLoading,
    errorMessage: state.project.errorMessage,
    projectCreated: state.project.projectCreated,
    projectUpdated: state.project.projectUpdated,
  }));

  const [isAddModalOpen, setIsAddModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedProject, setSelectedProject] = useState<any>(null);

  const handleEdit = (rowData: any) => {
    setSelectedProject(rowData);
    setIsEditModalOpen(true);
  };

  const handleDelete = (data: any) => {
    const softDeleteData = {
      ...data,
      is_deleted: true,
      is_active: false,
    }
    dispatch(updateProject(data.id, softDeleteData, setIsEditModalOpen));
  };

  const actionButton = (rowData: any) => {
    return (
      <div className="table-actions d-flex">
        <Link
          className="delete-table me-2"
          to="#"
          onClick={() => handleEdit(rowData)}
        >
          <Icon.Edit className="react-feather-custom" />
        </Link>
        <Link
          onClick={() => {
            handleDelete(rowData);
          }}
          className="delete-table border-none"
          to="#"
        >
          <Icon.Trash2 className="react-feather-custom" />
        </Link>
      </div>
    );
  };

  useEffect(() => {
    dispatch(getAllProjects());
    
    return () => {
      dispatch({ type: 'RESET_PROJECT_ERRORS' });
    };
  }, [dispatch, projectCreated, projectUpdated]);

  return (
    <>
      <Toast ref={toast} />

      <div className="page-wrapper page-settings" style={{ paddingTop: '0px' }}>
        <div className="content">
          <div
            style={{
              display: 'flex',
              justifyContent: 'space-between',
              flexDirection: 'row',
              gap: 20,
              alignItems: 'center',
              paddingBottom: '2rem',
              flexWrap: 'wrap',
            }}
          >
            <Col
              style={{
                maxWidth: '700px',
              }}
            >
              <h5 style={{ margin: '0 0 2rem 0', padding: 0 }}>Projects</h5>
           
            </Col>

            <button
                className="btn btn-primary"
                type="button"
                onClick={() => setIsAddModalOpen(true)}
              >
              <i className="fa fa-plus me-2" />
              Add Project
            </button>
          </div>

          <div className="row">
            <div className="col-12">
              <div className="table-resposnive">
                <DataTable
                  paginatorTemplate="RowsPerPageDropdown CurrentPageReport PrevPageLink PageLinks NextPageLink"
                  currentPageReportTemplate="{first} to {last} of {totalRecords}"
                  value={projects}
                  showGridlines
                  tableStyle={{ minWidth: '50rem' }}
                  loading={isLoading}
                  emptyMessage={
                    !isLoading && (
                      <TableNotFound
                        Icon={Icon.FileText}
                        title={
                          'No Projects Found'
                        }
                      />
                    )
                  }
                >
                  <Column
                    header="#"
                    body={(rowData, options) => options.rowIndex + 1}
                    style={{ width: '3rem' }}
                  ></Column>
                  <Column
                    sortable
                    field="name"
                    header="Name"
                  ></Column>
                  <Column
                    sortable
                    field="description"
                    header="Description"
                  ></Column>
                  <Column sortable field="start_date" header="Start Date"
                  body={(rowData) => {
                    return formatDate(rowData.start_date);
                  }}
                  ></Column>
                  <Column sortable field="created_at" header="Created At"
                  body={(rowData) => {
                    return formatDate(rowData.created_at.split('T')[0]);
                  }}
                  ></Column>
                  <Column sortable field="is_active" header="Status"></Column>
                  <Column sortable field="is_deleted" header="Deleted"></Column>
                  
                  <Column
                    field="action"
                    header="Actions"
                    body={actionButton}
                  ></Column>
                </DataTable>
              </div>
            </div>
          </div>
        </div>
      </div>
      <ProjectsModal
        selectedProject={selectedProject}
        setIsAddModalOpen={setIsAddModalOpen}
        isAddModalOpen={isAddModalOpen}
        isEditModalOpen={isEditModalOpen}
        setIsEditModalOpen={setIsEditModalOpen}
      />
    </>
  );
};

export default ListProjects; 